import React from 'react';
// @ts-ignore
import css from './sectionSlider.module.scss'
import {getPluralForm} from "../helpers";
import SliderDownload from './../main/sliderDownload/sliderDownload'
import SectionSliderPreview from "./sectionSlider/sectionSliderPreview";

const SectionSlider = ({data, lots, mapData, hasDownloadRoute, dataAgent, slideIndex }: any) => {
    const images = data?.housing_complex?.apartments?.[0]?.housing_complex?.images || [];

    const hcDesc = {
        lots: hasDownloadRoute ? lots : lots + ' ' + getPluralForm(lots, ['объект', 'объекта', 'объектов']),
        city: data.housing_complex?.apartments[0]?.housing_complex?.name,
        address: data.housing_complex?.apartments[0]?.housing_complex?.address,
        name: data.housing_complex?.housing_complex_name
    }

    return (
        <section className={'flex flex-col max-md:gap-[16px] gap-[30px] w-full'}>
            {
                hasDownloadRoute ?
                    <SliderDownload hcDesc={hcDesc} images={images} dataAgent={dataAgent} slideIndex={slideIndex + 1}/>
                    :
                    <SectionSliderPreview images={images} data={data} mapData={mapData} hcDesc={hcDesc} hasDownloadRoute={hasDownloadRoute}/>
            }
        </section>
    );
};

export default SectionSlider;